export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-26-C-front-side-WEB-Large-f1a1cf6ee0a0d76a7e42561a48fb2908.jpg";